import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-amianto-view',
  templateUrl: './form-amianto-view.component.html',
  styleUrls: ['./form-amianto-view.component.css']
})
export class FormAmiantoViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
